import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { TnbUser } from '../../service/auth/tnb-user';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';
import { take } from 'rxjs/operators';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';
import { ActivatedRoute } from '@angular/router';
import { RoutingService } from '../../service/common/routing/routing.service';

@Component({
    selector: 'tnb-uptodate-confirmation',
    templateUrl: './uptodate-confirmation.component.html',
    styleUrls: [
        './uptodate-confirmation.component.scss',
    ],
    standalone: false,
})
export class UptodateConfirmationComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private netzbetreiberService = inject(NetzbetreiberService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private readonly routingService = inject(RoutingService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public tnbUser: TnbUser;

    public recentlyConfirmed = false;
    public lastChanged: Date = null;

    constructor() {
        this.tnbUser = this.route.snapshot.data.profile;
    }

    public static sameDay(d1, d2) {
        return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }

    ngOnInit() {
        // show this dialog only to Stadtwerke-Users
        if (this.tnbUser.netzbetreiberType === 'STADTWERK') {
            this.netzbetreiberService.getNetzbetreiber(this.teilgebietSelectionService.getSelectedStadtwerkeId())
                .pipe(take(1))
                .subscribe(nb => {
                    this.lastChanged = new Date(nb.lastChanged);
                    this.recentlyConfirmed = UptodateConfirmationComponent.sameDay(this.lastChanged, new Date());
                    this.changeDetectorRef.markForCheck();
                });
        }
    }

    public get routerLink(): string | null {
        return this.routingService.erzeugungsanlagePath();
    }
}
